import React, { Component } from 'react'

import { connect } from 'react-redux'
import * as actions from '../../../../store/actions'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'

import AppraisalResultContent from '../../../../components/PageContent/Appraisal/AppraisalResult/AppraisalResultContent'
import Alert from '../../../../components/Alert/Alert'
import CommentModal from '../../../../components/PageContent/Appraisal/AppraisalResult/CommentModal/CommentModal'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import ActionToModal from '../../../../components/PageContent/Employee/ActionToModal/ActionToModal'
import {
  getSelectvalue,
  updateFormData,
  updateObject,
  extractFormData
} from '../../../../helpers/utils'
import { isNull } from 'lodash'

class AppraisalResult extends Component {
  state = {
    appraisalData: [],
    appraisalDataCache: null,
    commentList: [],
    commentListCache: null,
    commentModalOpen: false,
    targetResultKpiId: null,
    commentStructureType: null,
    confirmationModalOpen: false,
    actionToModalOpen: false,
    empActionTo: [],
    actionToRowTemplate: {
      assessor_group_id: {
        value: 0,
        valid: true
      },
      structure_id: {
        elementType: 'static',
        value: null,
        valid: true
      },
      seq_no: {
        label: 'Seq No.',
        elementType: 'input',
        elementConfig: {
          placeholder: 'Seq No.',
          inputProps: {
            maxLength: 3
          }
        },
        valid: false,
        validation: {
          required: true,
          isDecimal: true
        },
        value: '',
        touched: false,
        error: null
      },
      position_group_id: {
        label: this.props.translate('positionGroup'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('positionGroup'),
          dropUp: true,
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      emp_id: {
        label: this.props.translate('employee'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_id: {
        label: this.props.translate('position'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      org_id: {
        label: this.props.translate('organization'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: [],
          disabled: true
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      }
    }
  }

  static getDerivedStateFromProps(props, state) {
    let updatedState = {}
    if (props.appraisalData !== state.appraisalDataCache) {
      updatedState = {
        ...updatedState,
        appraisalData: props.appraisalData,
        appraisalDataCache: props.appraisalData
      }
    }
    if (props.commentList !== state.commentListCache) {
      updatedState = {
        ...updatedState,
        commentList: props.commentList,
        commentListCache: props.commentList
      }
    }
    return updatedState
  }

  componentDidMount() {
    const resultId = this.props.match.params.id

    if (!resultId && resultId !== 0) {
      this.props.history.replace('/appraisal')
    } else {
      this.props.fetchAppraisalResultData(resultId)
    }

    this.props.fetchCompetencyTypes()
  }

  componentDidUpdate(prevProps) {
    const { appraisalInfo, saveActionToSuccess } = this.props
    const oldActionToSuccess = prevProps.saveActionToSuccess
    const oldAppraisalInfo = prevProps.appraisalInfo
    if (oldAppraisalInfo !== appraisalInfo) {
      const empDetailId = appraisalInfo.emp_detail_id || null
      const companyId = appraisalInfo?.company_id || null
      const params = { company_id: companyId }

      if (empDetailId) {
        this.props.fetchActionToOptions(params)
      }
    }

    if (saveActionToSuccess && saveActionToSuccess !== oldActionToSuccess) {
      this.actionToCancelledHandler()
    }
  }

  componentWillUnmount() {
    this.setState({
      appraisalData: [],
      appraisalDataCache: null,
      commentList: [],
      commentListCache: null,
      commentModalOpen: false,
      targetResultKpiId: null,
      commentStructureType: null,
      confirmationModalOpen: false,
      actionToModalOpen: false,
      empActionTo: [],
      actionToRowTemplate: {
        assessor_group_id: {
          value: 0,
          valid: true
        },
        seq_no: {
          label: 'Seq No.',
          elementType: 'input',
          elementConfig: {
            placeholder: 'Seq No.',
            inputProps: {
              maxLength: 3
            }
          },
          valid: false,
          validation: {
            required: true,
            isDecimal: true
          },
          value: '',
          touched: false,
          error: null
        },
        position_group_id: {
          label: this.props.translate('positionGroup'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('positionGroup'),
            dropUp: true,
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        emp_id: {
          label: this.props.translate('employee'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('employee'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        position_id: {
          label: this.props.translate('position'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('position'),
            options: []
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        },
        org_id: {
          label: this.props.translate('organization'),
          elementType: 'newselect',
          elementConfig: {
            placeholder: this.props.translate('select') + this.props.translate('organization'),
            options: [],
            disabled: true
          },
          value: '',
          validation: {
            required: true
          },
          valid: false,
          touched: false,
          error: null
        }
      }
    })
    this.props.clearSelectedAppraisalData()
  }

  appraisalInputChangedHandler = updatedStructure => {
    this.setState(prevState => {
      const updatedAppraisalData = [...prevState.appraisalData].map(structure => {
        if (+structure.result_structure_id === +updatedStructure.result_structure_id) {
          return { ...structure, ...updatedStructure }
        }
        return structure
      })
      return {
        appraisalData: [...updatedAppraisalData]
      }
    })
  }

  openCommentModalHandler = (targetResultKpiId, structureType) => {
    if (!structureType || !targetResultKpiId) {
      return
    } else {
      this.setState({
        commentModalOpen: true,
        targetResultKpiId: targetResultKpiId,
        commentStructureType: structureType
      })
      this.props.fetchComments(targetResultKpiId, structureType)
    }
  }

  closeCommentModalHandler = () => {
    this.setState({
      commentModalOpen: false,
      targetResultKpiId: null,
      commentStructureType: null,
      commentList: []
    })
  }

  commentSubmittedHandler = (commentContent, commentFile) => {
    this.props.postComment(
      this.state.targetResultKpiId,
      this.state.commentStructureType,
      commentContent,
      commentFile
    )
  }

  downloadCommentFileHandler = commentId => {
    this.props.downloadCommentAttachment(commentId, this.state.commentStructureType)
  }

  deleteCommentHandler = commentId => {
    this.props.deleteComment(
      this.state.targetResultKpiId,
      commentId,
      this.state.commentStructureType
    )
  }

  submitClickedHandler = resultStructureId => {
    const targetStructure = this.state.appraisalData.filter(
      struct => +struct.result_structure_id === +resultStructureId
    )
    const data = { ...this.props.appraisalInfo, result_structure: targetStructure }

    this.props.saveAppraisal(data)
  }

  cancelClickedHandler = () => this.setState({ confirmationModalOpen: true })

  calculateClickedHandler = () => {
    const data = { ...this.props.appraisalInfo, result_structure: [...this.state.appraisalData] }

    this.props.calculateAppraisal(data)
  }

  openActionToModalHandler = structId => {
    const { actionToOptions, assessorGroups, appraisalInfo, isAdmin } = this.props
    const { actionToRowTemplate } = this.state
    const empDetailId = appraisalInfo?.emp_detail_id || null
    const rawActionTo = appraisalInfo?.emp_detail?.action_to || null
    const filteredAssessorGroups =
      assessorGroups?.filter(asGroup => !['ASG04', 'ASG05'].includes(asGroup.value_list_code)) ||
      []
    const allOptionsLoaded = Object.values(actionToOptions).every(item => !!item)

    if (!assessorGroups || !appraisalInfo || !empDetailId || !allOptionsLoaded) return

    const mapper = {
      emp_id: {
        key: 'emp_id',
        value: 'emp_id',
        label: { name: 'full_name', code: 'emp_code' },
        options: actionToOptions.empOptions
      },
      org_id: {
        key: 'org_id',
        value: 'org_id',
        label: { name: 'org_name', code: 'org_code' },
        options: actionToOptions.orgOptions
      },
      position_id: {
        key: 'position_id',
        value: 'position_id',
        label: { name: 'position_name', code: 'position_code' },
        options: actionToOptions.positionOptions
      },
      position_group_id: {
        key: 'position_group_id',
        value: 'position_group_id',
        label: { name: 'position_group_name', code: 'position_group_code' },
        options: actionToOptions.positionGroupOptions
      }
    }

    let actionTo = []

    actionTo = filteredAssessorGroups.map(assessorGroup => {
      const { value_list_id, value_list_name, value_list_code } = assessorGroup
      const recordsbyGroup = (rawActionTo || [])
        .filter(item => item.assessor_group_id === value_list_id)
        .map(actionTo => {
          const transformedActionTo = Object.entries({ ...actionToRowTemplate }).reduce(
            (transformed, formItem) => {
              let [itemKey, itemAttr] = formItem

              let value = actionTo[itemKey]

              if (itemKey === 'structure_id') {
                value = structId
              }

              let rawValue = null

              if (['emp_id', 'org_id', 'position_id'].includes(itemKey)) {
                if (actionTo.empdetail) {
                  rawValue = actionTo.empdetail[itemKey]
                }
                const rawDropdownValue = getSelectvalue(rawValue, mapper[itemKey].options, itemKey)
                if (rawDropdownValue) {
                  const dropdownValue = {
                    key: rawDropdownValue[mapper[itemKey]?.key],
                    value: rawDropdownValue[mapper[itemKey]?.value],
                    label: `${rawDropdownValue[mapper[itemKey]?.label.code]} - ${
                      rawDropdownValue[mapper[itemKey]?.label.name]
                    }`
                  }
                  value = dropdownValue
                }
              }
              if ('position_group_id' === itemKey) {
                rawValue = actionTo.action2_position_group_id
                const rawDropdownValue = getSelectvalue(rawValue, mapper[itemKey].options, itemKey)
                if (rawDropdownValue) {
                  const dropdownValue = {
                    key: rawDropdownValue[mapper[itemKey]?.key],
                    value: rawDropdownValue[mapper[itemKey]?.value],
                    label: `${rawDropdownValue[mapper[itemKey]?.label.code]} - ${
                      rawDropdownValue[mapper[itemKey]?.label.name]
                    }`
                  }
                  value = dropdownValue
                }
              }

              let updatedItemAttr = {
                ...itemAttr,
                elementConfig: {
                  disabled: !isAdmin
                },
                value: value
              }

              return {
                ...transformed,
                [itemKey]: updatedItemAttr
              }
            },
            { ...actionTo }
          )

          return transformedActionTo
        })

      return {
        groupId: value_list_id,
        groupName: value_list_name,
        groupCode: value_list_code,
        collapsed: value_list_id !== 1,
        records: recordsbyGroup
      }
    })

    this.setState({
      actionToModalOpen: true,
      empActionTo: actionTo
    })
  }

  actionToCancelledHandler = () => {
    this.setState({
      actionToModalOpen: false,
      empActionTo: []
    })
  }

  actionToCollapseClickedHandler = groupId => {
    this.setState(prevState => {
      const updated = prevState.empActionTo.map(item => {
        if (item.groupId === groupId) {
          item.collapsed = !item.collapsed
        }
        return item
      })

      return {
        empActionTo: updated
      }
    })
  }

  actionToAddRowHandler = groupId => {
    const { isAdmin } = this.props
    if (!isAdmin) return
    const updated = this.state.empActionTo.map(item => {
      if (item.groupId === groupId) {
        const updatedActionTo = {
          ...this.state.actionToRowTemplate,
          assessor_group_id: { value: groupId, valid: true }
        }
        const updatedRecords = [...item.records, { ...updatedActionTo }]
        return { ...item, records: updatedRecords }
      }
      return item
    })
    this.setState({
      empActionTo: updated
    })
  }

  actionToRemoveRowHandler = (groupId, index) => {
    const { isAdmin } = this.props
    if (!isAdmin) return
    const updated = this.state.empActionTo.map(item => {
      if (item.groupId === groupId) {
        item.records.splice(index, 1)
      }
      return item
    })
    this.setState({
      empActionTo: updated
    })
  }

  actionToChangedHandler = (groupId, index, formKey, event) => {
    const { isAdmin } = this.props
    if (!isAdmin) return
    const updated = this.state.empActionTo.map(item => {
      if (item.groupId === groupId) {
        const targetRow = item.records[index]
        let formItem = targetRow[formKey]
        const updatedFormItem = updateFormData(formItem, event)
        const inputValue = updatedFormItem.value

        let updatedRow = updateObject(targetRow, { [formKey]: updatedFormItem })

        if (formKey === 'emp_id' && !isNull(inputValue)) {
          let mainJob = this.props.actionToOptions.empOptions
            .find(res => res.emp_id === inputValue?.value)
            .empdetails.find(main => main.is_main_job === 1)

          let mainPosition =
            getSelectvalue(
              parseInt(mainJob.position_id),
              this.props.actionToOptions.positionOptions,
              'position_id'
            ) || null

          let positionValue = mainPosition
            ? {
                key: mainPosition.position_id,
                value: mainPosition.position_id,
                label: `${mainPosition.position_code} ${mainPosition.position_name}`
              }
            : null

          let mainOrg =
            getSelectvalue(
              parseInt(mainJob.org_id),
              this.props.actionToOptions.orgOptions,
              'org_id'
            ) || null

          let orgValue = mainOrg
            ? {
                key: mainOrg.org_id,
                value: mainOrg.org_id,
                label: `${mainOrg.org_code} ${mainOrg.org_name}`
              }
            : null

          updatedRow = updateObject(targetRow, {
            [formKey]: updatedFormItem,
            position_id: { ...targetRow.position_id, value: positionValue },
            org_id: { ...targetRow.org_id, value: orgValue }
          })
        }
        if (formKey === 'position_id') {
          let selectedEmp = this.props.actionToOptions.empOptions
            .find(res => {
              return res.emp_id === targetRow.emp_id.value.value
            })
            .empdetails.find(item => parseInt(item.position_id) === event.value)

          let org = getSelectvalue(
            selectedEmp.org_id,
            this.props.actionToOptions.orgOptions,
            'org_id'
          )

          let orgValue = org
            ? {
                key: org.org_id,
                value: org.org_id,
                label: `${org.org_code} ${org.org_name}`
              }
            : null

          updatedRow = updateObject(targetRow, {
            [formKey]: updatedFormItem,
            org_id: { ...targetRow.org_id, value: orgValue }
          })
        }

        item.records[index] = updatedRow
      }

      return item
    })

    this.setState({
      empPositionActionTo: updated
    })
  }

  actionToSubmittedHandler = () => {
    const { isAdmin } = this.props
    if (!isAdmin) return
    let data = []
    const { appraisalInfo } = this.props
    const empDetailId = appraisalInfo.emp_detail_id
    const resultId = appraisalInfo.result_id

    this.state.empActionTo.forEach(group => {
      group.records.forEach(record => {
        data.push(extractFormData(record, { emp_detail_id: empDetailId }))
      })
    })

    this.props.saveActionTo(data, resultId)
  }

  openConfirmationModalHandler = () => {
    this.setState({
      confirmationModalOpen: true
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      confirmationModalOpen: false
    })
  }

  appraisalCancelledHandler = () => {
    this.props.history.replace('/appraisal')
    this.closeConfirmationModal()
  }

  sumUpClickedHandler = () => {
    const { structure_id, result_id } = this.props.appraisalInfo
    this.props.sumUp({ structure_id, result_id })
  }

  render() {
    return (
      <Aux>
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          header={this.props.translate('cancelAppraisal')}
          promptText={this.props.translate('confirmLeavePage')}
          confirmed={this.appraisalCancelledHandler}
          cancelled={this.closeConfirmationModal}
        />
        <Alert />
        <CommentModal
          open={this.state.commentModalOpen}
          commentSubmitted={this.commentSubmittedHandler}
          commentList={this.state.commentList}
          closed={this.closeCommentModalHandler}
          downloadClicked={this.downloadCommentFileHandler}
          deleteClicked={this.deleteCommentHandler}
        />
        <ActionToModal
          open={this.state.actionToModalOpen}
          actionToData={this.state.empActionTo}
          dropdownOptions={this.props.actionToOptions}
          currentCompany={this.props.appraisalInfo.company_id}
          currentEmp={this.props.appraisalInfo.emp?.emp_code || null}
          cancelled={this.actionToCancelledHandler}
          submitted={this.actionToSubmittedHandler}
          inputChanged={this.actionToChangedHandler}
          addRowClicked={this.actionToAddRowHandler}
          deleteRowClicked={this.actionToRemoveRowHandler}
          collapseClicked={this.actionToCollapseClickedHandler}
        />
        <AppraisalResultContent
          appraisalData={[...this.state.appraisalData]}
          appraisalInfo={this.props.appraisalInfo}
          competencyTypes={this.props.competencyTypes}
          openCommentModal={this.openCommentModalHandler}
          inputChanged={this.appraisalInputChangedHandler}
          calculateButtonClicked={this.calculateClickedHandler}
          submitButtonClicked={this.submitClickedHandler}
          cancelButtonClicked={this.cancelClickedHandler}
          showActionTo={!!this.props.appraisalInfo.emp_detail_id}
          actionToButtonClicked={this.openActionToModalHandler}
          showSumUp={true}
          sumUpButtonClicked={this.sumUpClickedHandler}
          savedList={this.props.savedList}
          loadingStates={this.props.loadingStates}
          isAdmin={this.props.isAdmin}
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => ({
  appraisalData: state.appraisal.appraisalData,
  appraisalInfo: state.appraisal.appraisalInfo,
  commentList: state.appraisal.commentList,
  savedList: state.appraisal.appraisalSavedList,
  loadingStates: state.appraisal.loadingStates,
  isAdmin: state.auth.isAdmin,
  assessorGroups: state.appraisal.assessorGroups,
  actionToOptions: state.appraisal.actionToOptions,
  competencyTypes: state.appraisal.competencyTypes,
  saveActionToSuccess: state.appraisal.saveActionToSuccess
})

const mapDispatchToProps = dispatch => ({
  fetchAppraisalResultData: resultId => dispatch(actions.fetchAppraisalResultData(resultId)),
  fetchCompetencyTypes: () => dispatch(actions.fetchCompetencyTypeOptions()),
  fetchScoreOptions: filterOptions => dispatch(actions.fetchCompetencyScoreOptions(filterOptions)),
  saveAppraisal: data => dispatch(actions.saveAppraisal(data)),
  calculateAppraisal: data => dispatch(actions.calculateAppraisal(data)),
  fetchComments: (kpiId, type) => dispatch(actions.fetchAppraisalComments(kpiId, type)),
  postComment: (id, stType, content, file) =>
    dispatch(actions.postAppraisalComments(id, stType, content, file)),
  deleteComment: (kpiId, commentId, stType) =>
    dispatch(actions.deleteAppraisalComment(kpiId, commentId, stType)),
  downloadCommentAttachment: (commentId, type) =>
    dispatch(actions.downloadCommentAttachment(commentId, type)),
  clearSelectedAppraisalData: () => dispatch(actions.clearSelectedAppraisalData()),
  fetchActionToOptions: filterParams => {
    dispatch(actions.fetchCompanyOptions())
    dispatch(actions.fetchOrganizationOptions({ is_position_group_level: false }))
    dispatch(actions.fetchPositionGroupOptions({ ...filterParams, is_position_group_level: false }))
    dispatch(actions.fetchPositionOptions({ is_position_group_level: false }))
    dispatch(actions.fetchEmployeeOptions({ ...filterParams, is_position_group_level: false }))
    dispatch(actions.fetchAssessorGroupOptions())
  },
  saveActionTo: (data, resultId) => dispatch(actions.saveActionTo(data, resultId)),
  sumUp: payload => dispatch(actions.sumUp(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(AppraisalResult))
